import React, { useState } from 'react';
import { Activity, Briefcase, Calendar, Users, Sparkles, DollarSign, FileText, FolderOpen, BookOpen, BarChart3, Eye, Settings, HelpCircle, Menu } from 'lucide-react';

const BottomTabBar = ({ activeTab, setActiveTab }) => {
  const [showMore, setShowMore] = useState(false);
  const mainTabs = [
    { id: 'dashboard', label: 'Home', Icon: Activity },
    { id: 'cases', label: 'Cases', Icon: Briefcase },
    { id: 'tasks', label: 'Tasks', Icon: Calendar },
    { id: 'clients', label: 'Clients', Icon: Users },
    { id: 'ai-assistant', label: 'Paralegal', Icon: Sparkles },
  ];
  const moreTabs = [
    { id: 'billing', label: 'Billing & Time', Icon: DollarSign },
    { id: 'documents', label: 'Documents', Icon: FileText },
    { id: 'templates', label: 'Templates', Icon: FolderOpen },
    { id: 'legal-research', label: 'Research', Icon: BookOpen },
    { id: 'analytics', label: 'Analytics', Icon: BarChart3 },
    { id: 'team', label: 'Team Hub', Icon: Users },
    { id: 'audit', label: 'Audit Trail', Icon: Eye },
    { id: 'admin', label: 'Admin', Icon: Settings },
    { id: 'contact', label: 'Contact Us', Icon: HelpCircle },
  ];
  const isMoreActive = moreTabs.some(t => t.id === activeTab);

  return (<>
    {/* More menu slide-up */}
    {showMore && (
      <div onClick={() => setShowMore(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 998 }}>
        <div onClick={e => e.stopPropagation()} style={{ position: 'fixed', bottom: '60px', left: 0, right: 0, background: '#0f1219', borderTopLeftRadius: '16px', borderTopRightRadius: '16px', padding: '1rem', boxShadow: '0 -4px 20px rgba(0,0,0,0.4)', maxHeight: '60vh', overflowY: 'auto' }}>
          <div style={{ width: '32px', height: '4px', background: 'rgba(255,255,255,0.2)', borderRadius: '2px', margin: '0 auto 1rem' }} />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem' }}>
            {moreTabs.map(tab => (
              <button key={tab.id} onClick={() => { setActiveTab(tab.id); setShowMore(false); }} style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.35rem',
                padding: '0.85rem 0.5rem', background: activeTab === tab.id ? 'rgba(212,168,83,0.15)' : 'rgba(255,255,255,0.03)',
                border: activeTab === tab.id ? '1px solid rgba(212,168,83,0.3)' : '1px solid rgba(255,255,255,0.06)',
                borderRadius: '12px', cursor: 'pointer', color: activeTab === tab.id ? '#d4a853' : '#a8adb7',
                fontSize: '0.72rem', fontFamily: 'inherit', fontWeight: activeTab === tab.id ? 600 : 400
              }}>
                <tab.Icon size={22} />
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    )}
    {/* Bottom bar */}
    <nav style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 997,
      background: 'rgba(10,13,20,0.97)', borderTop: '1px solid rgba(255,255,255,0.08)',
      display: 'flex', justifyContent: 'space-around', alignItems: 'center',
      padding: '0.3rem 0', paddingBottom: 'max(0.3rem, env(safe-area-inset-bottom))',
      backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)'
    }}>
      {mainTabs.map(tab => {
        const isActive = activeTab === tab.id;
        return (
          <button key={tab.id} onClick={() => { setActiveTab(tab.id); setShowMore(false); }} style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.15rem',
            background: 'none', border: 'none', cursor: 'pointer', padding: '0.35rem 0.5rem',
            color: isActive ? '#d4a853' : '#6b7280', fontSize: '0.62rem', fontFamily: 'inherit',
            fontWeight: isActive ? 700 : 400, minWidth: '52px', transition: 'color 0.15s'
          }}>
            <tab.Icon size={20} strokeWidth={isActive ? 2.2 : 1.8} />
            <span>{tab.label}</span>
            {isActive && <div style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#d4a853', marginTop: '-2px' }} />}
          </button>
        );
      })}
      <button onClick={() => setShowMore(!showMore)} style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.15rem',
        background: 'none', border: 'none', cursor: 'pointer', padding: '0.35rem 0.5rem',
        color: isMoreActive || showMore ? '#d4a853' : '#6b7280', fontSize: '0.62rem', fontFamily: 'inherit',
        fontWeight: isMoreActive ? 700 : 400, minWidth: '52px'
      }}>
        <Menu size={20} strokeWidth={isMoreActive ? 2.2 : 1.8} />
        <span>More</span>
        {isMoreActive && <div style={{ width: '4px', height: '4px', borderRadius: '50%', background: '#d4a853', marginTop: '-2px' }} />}
      </button>
    </nav>
  </>);
};

export default BottomTabBar;
